import { render, staticRenderFns } from "./PencapaianPertumbuhanOutlet.vue?vue&type=template&id=0677de66"
import script from "./PencapaianPertumbuhanOutlet.vue?vue&type=script&lang=js"
export * from "./PencapaianPertumbuhanOutlet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports